import type { DropdownDimensionProps } from "../../components/dimensions";
import { DimensionTypes } from "../../types/dimensions";

import type { DimensionFixtureExample } from ".";

export const DropdownDimensionFixtures: Record<string, DropdownDimensionProps> =
    {
        baseProps: {
            id: "base",
            configuration: {
                itemMapper: {
                    value: "marketplace_id",
                    label: "locale",
                },
                inputSource: "marketplaces",
                label: "Marketplaces",
            },
            dependencies: [],
            type: DimensionTypes.DROPDOWN,
        },
    };

export const DropdownDimensionExamples: Record<
    string,
    DimensionFixtureExample
> = {
    base: {
        id: "dropdown_base",
        name: "dropdown dimension base",
        description: "only works with mock server",
        dimensions: [[DropdownDimensionFixtures.baseProps]],
    },
    dependency: {
        id: "dropdown_dependency",
        name: "dropdown dimension dependency",
        description: "only works with mock server",
        dimensions: [
            [
                {
                    ...DropdownDimensionFixtures.baseProps,
                },
                {
                    id: "dependency",
                    type: DimensionTypes.DROPDOWN,
                    dependencies: ["base"],
                    configuration: {
                        label: "dependency",
                        itemMapper: {
                            value: "marketplace_id",
                            label: "locale",
                        },
                        inputSource: "marketplaces",
                        inputParameterFilters: [
                            {
                                key: "base",
                                dimension: "base",
                                condition: "EQUALS",
                            } as any,
                        ],
                    },
                },
            ],
        ],
    },
};
